<template>
  <RygenChip
    v-if="status"
    v-tooltip="tooltip"
    :severity="severity"
    :label="label"
  />
</template>

<script lang="ts" setup>
import { computed, PropType, toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { useTooltip } from '@rygen/rygen-ui/composables';
import { translateEnum } from '@rygen/rygen-ui/i18n';
import { Severity } from '@rygen/rygen-ui/model';

import { SpotMarketStatus } from '@/model';

import RygenChip from '@rygen/rygen-ui/components/ui/RygenChip.vue';

const props = defineProps({
  status: {
    type: String as PropType<SpotMarketStatus>,
    default: () => '',
  },
});
const { status } = toRefs(props);

const { t } = useI18n();
const vTooltip = useTooltip();

const label = computed((): string => {
  return translateEnum(status.value, 'SpotMarketStatus');
});

const tooltip = computed((): string => {
  return t(`carrierPortal.spotMarket.status.${status.value}`);
});

const severity = computed(() => {
  switch (status?.value) {
    case SpotMarketStatus.SENDING:
      return Severity.INFO;
    case SpotMarketStatus.REQUESTED:
      return Severity.INFO;
    case SpotMarketStatus.ACCEPTED:
      return Severity.SUCCESS;
    case SpotMarketStatus.EXPIRED:
      return Severity.DANGER;
    case SpotMarketStatus.REJECTED:
      return Severity.DANGER;
    case SpotMarketStatus.FAILED:
      return Severity.DANGER;
    case SpotMarketStatus.CANCELLED:
      return Severity.DANGER;
    default:
      return undefined;
  }
});
</script>
